{
  "FormSaveButton": {
    "save": "Zapisz"
  },
  "StickyFormActionsBar": {
    "toolbarLabel": "Akcje formularza",
    "hotkeyHintBefore": "Naciśnij",
    "hotkeyHintAfter": "aby zapisać zmiany",
    "cancel": "Anuluj"
  },
  "DialogErrorFooter": {
    "error": "Błąd"
  },
  "FormDialogContent": {
    "save": "Zapisz"
  },
  "ArchiveConfirmationDialog": {
    "archiveTitle": "Zarchiwizować {{entityName}}?",
    "unarchiveTitle": "Przywrócić {{entityName}}?",
    "archiveDescription": "Czy na pewno chcesz zarchiwizować ten {{entityName}}? Nie utracisz żadnych danych.",
    "unarchiveDescription": "Czy na pewno chcesz przywrócić ten {{entityName}}?",
    "archiveConfirm": "Archiwizuj",
    "unarchiveConfirm": "Przywróć",
    "cancel": "Anuluj",
    "confirmInProgress": "{{label}}…",
    "confirmRetry": "{{label}} (Ponów)",
    "srDescriptionArchive": "Okno potwierdzenia archiwizacji {{entityName}}.",
    "srDescriptionUnarchive": "Okno potwierdzenia przywracania {{entityName}}."
  },
  "FileUploadDropzone": {
    "dropFilesOrClickOrPaste": "Upuść pliki tutaj, kliknij, aby wybrać, lub wklej",
    "weAccept": "Akceptujemy {{formats}}",
    "acceptImages": "obrazy"
  },
  "FinancialDocumentDialog": {
    "addInvoice": "Dodaj fakturę",
    "addReceipt": "Dodaj paragon",
    "editInvoice": "Edytuj fakturę",
    "editReceipt": "Edytuj paragon",
    "create": "Utwórz",
    "invoice": "Faktura",
    "invoices": "Faktury",
    "receipt": "Paragon",
    "receipts": "Paragony",
    "expense": "Wydatek",
    "expensePlaceholder": "Wybierz wydatek",
    "reference": "Odnośnik",
    "referencePlaceholder": "Wpisz odnośnik",
    "amount": "Kwota",
    "status": "Status",
    "statusPlaceholder": "Wybierz status",
    "file": "Plik",
    "fileDescription": "Obsługiwane formaty PDF i obrazów",
    "upload": "Prześlij",
    "attachedReceipt": "Załączony paragon",
    "documentCount": "{{count}} dokument",
    "documentCount_other": "{{count}} dokumentów",
    "unsavedChanges": "Masz niezapisane zmiany w formularzu dokumentu finansowego.",
    "download": "Pobierz",
    "openInNewTab": "Otwórz w nowej karcie",
    "untitled": "Bez tytułu",
    "noFileAttached": "Brak załączonego pliku",
    "documentSaved": "Dokument zapisany",
    "documentDeleted": "Dokument usunięty",
    "documentSaveFailed": "Nie udało się zapisać dokumentu",
    "documentDeleteFailed": "Nie udało się usunąć dokumentu",
    "allReconciledTooltip": "Wszystkie dokumenty uzgodnione: wartość faktyczna równa zobowiązaniom, a każdy dokument (z wyłączeniem oczekujących na zatwierdzenie) ma status Opłacony lub Zatwierdzony.",
    "underCommittedTooltip": "Poniżej zobowiązań: wydatki faktyczne są niższe niż kwota zobowiązań.",
    "overCommittedTooltip": "Powyżej zobowiązań: wydatki faktyczne przekraczają kwotę zobowiązań."
  },
  "UnsavedChangesDialog": {
    "title": "Niezapisane zmiany",
    "description": "Masz niezapisane zmiany. Czy na pewno chcesz wyjść? Twoje zmiany zostaną utracone.",
    "cancel": "Kontynuuj edycję",
    "confirm": "Odrzuć zmiany",
    "beforeUnload": "Masz niezapisane zmiany. Czy na pewno chcesz wyjść?"
  },
  "EnumFilterWidget": {
    "operator": {
      "matchAny": "jest dowolnym z",
      "matchAll": "jest wszystkimi z",
      "matchNone": "jest żadnym z",
      "empty": "jest puste",
      "notEmpty": "nie jest puste"
    },
    "searchPlaceholder": "Wyszukaj wartość",
    "emptyValue": "Wybierz…",
    "valueNotRequired": "Brak wymaganych wartości"
  },
  "DateFilterCustomDialog": {
    "title": "Własna data lub przedział",
    "enterHumanDate": "Wpisz datę słownie",
    "humanPlaceholder": "np. następne 7 dni, jutro, 2025-01-14, 20 sty - 27 sty",
    "examples": "Przykłady: „następne 7 dni”, „jutro”, „20 sty - 27 sty”",
    "or": "albo",
    "setSpecificDate": "Ustaw konkretną datę",
    "single": "Pojedyncza",
    "range": "Zakres",
    "clear": "Wyczyść",
    "willApply": "Zostanie zastosowane:",
    "apply": "Zastosuj"
  },
  "DateFilterWidget": {
    "operator": {
      "between": "pomiędzy",
      "after": "po",
      "before": "przed",
      "equal": "w dniu"
    },
    "emptyValue": "Ustaw daty",
    "apply": "Zastosuj",
    "cancel": "Anuluj"
  },
  "BooleanFilterWidget": {
    "operator": {
      "is": "jest",
      "isNot": "nie jest"
    }
  },
  "NumberFilterWidget": {
    "title": "Ustaw liczbę",
    "operator": {
      "equal": "jest",
      "notEqual": "nie jest",
      "greaterThan": "większe niż",
      "lessThan": "mniejsze niż",
      "between": "pomiędzy"
    },
    "to": "do",
    "apply": "Zastosuj",
    "cancel": "Anuluj"
  },
  "StringFilterWidget": {
    "operator": {
      "equals": "jest",
      "contains": "zawiera",
      "notContains": "nie zawiera"
    },
    "placeholder": "Wpisz wartość",
    "emptyValue": "Ustaw wartość",
    "apply": "Zastosuj",
    "cancel": "Anuluj",
    "suggestionsIdleHint": "Zacznij pisać, aby wyszukać, lub wybierz ostatnie miejsce poniżej.",
    "suggestionsEmpty": "Brak pasujących miejsc. Spróbuj innej frazy.",
    "recentPlacesHeading": "Ostatnie"
  },
  "FilterWidgetAddControl": {
    "manageFilters": "Zarządzaj filtrami",
    "searchPlaceholder": "Wyszukaj filtry…",
    "emptySearch": "Brak pasujących filtrów"
  },
  "ArchivedTabs": {
    "all": "Wszystkie",
    "archived": "Zarchiwizowane"
  },
  "ActiveTabs": {
    "active": "Aktywne",
    "inactive": "Nieaktywne"
  },
  "SortableEntityTable": {
    "failedToLoadData": "Nie udało się załadować danych",
    "selectAllItems": "Zaznacz wszystkie",
    "selectItem": "Zaznacz {{key}}",
    "actionsSrOnly": "Akcje",
    "validationIssueSrOnly": "Problem z walidacją",
    "collapseRow": "Zwiń wiersz",
    "expandRow": "Rozwiń wiersz",
    "expandAllRows": "Rozwiń wszystkie wiersze",
    "collapseAllRows": "Zwiń wszystkie wiersze",
    "dragToReorder": "Zmień kolejność wiersza",
    "locked": "Zablokowane",
    "reorderSrOnly": "Zmiana kolejności",
    "clearSortToReorder": "Wyczyść sortowanie, aby zmienić kolejność"
  },
  "MediaCarousel": {
    "openMedia": "Otwórz media"
  },
  "MediaLoadStateOverlays": {
    "imageUnavailable": "Obraz niedostępny",
    "videoUnavailable": "Wideo niedostępne"
  },
  "EntityListToolbar": {
    "searchPlaceholder": "Szukaj...",
    "resourcesSearchPlaceholder": "Szukaj zasobów...",
    "clearAllFilters": "Wyczyść wszystkie filtry"
  },
  "EntityGridItem": {
    "noName": "Brak nazwy"
  },
  "CoreFields": {
    "status": "Status",
    "production_date": "Data produkcji",
    "code": "Kod",
    "archived": "Zarchiwizowane",
    "userId": "Właściciel",
    "productionTypeId": "Typ produkcji",
    "resource_type_id": "Typ",
    "organisation_id": "Organizacja",
    "represented_by_id": "Agent",
    "role": "Rola",
    "tags": "Tagi",
    "groups": "Grupy",
    "emails": "E-maile",
    "phone_numbers": "Telefony",
    "websites": "Strony internetowe",
    "socials": "Media społecznościowe",
    "locations": "Lokalizacje",
    "icon": "Ikona",
    "color": "Kolor",
    "title": "Tytuł",
    "description": "Opis",
    "budget_amount": "Kwota budżetu",
    "createdAt": "Utworzone",
    "updatedAt": "Zaktualizowane"
  },
  "CalloutSpecificFields": {
    "published": "Opublikowany",
    "archived": "Zarchiwizowany",
    "slug": "Slug URL"
  },
  "ResourceSpecificFields": {
    "groupName": "Specyficzne dla zasobu",
    "contact_type": "Typ zasobu",
    "emails": "E-maile",
    "phones": "Telefony",
    "websites": "Strony internetowe",
    "socials": "Media społecznościowe",
    "user_id": "Właściciel"
  },
  "ContactTypes": {
    "INDIVIDUAL": "Osoba",
    "ORGANIZATION": "Organizacja",
    "LOCATION": "Lokalizacja",
    "ITEM": "Przedmiot",
    "TALENT": "Talent",
    "AGENT": "Agent"
  },
  "CustomFields": {
    "today": "Dzisiaj"
  },
  "EntityTypes": {
    "production": "Produkcja",
    "booking": "Rezerwacja",
    "resource": "Zasób",
    "expense": "Wydatek"
  },
  "FilterGroups": {
    "coreFields": "Pola podstawowe",
    "customFields": "Pola niestandardowe"
  },
  "ReconciliationsTable": {
    "collapseAllDocuments": "Zwiń wszystkie dokumenty",
    "expandAllDocuments": "Rozwiń wszystkie dokumenty",
    "lineType": "Typ pozycji",
    "updatedAt": "Zaktualizowano",
    "vendorTooltipBooking": "Rezerwacja",
    "vendorTooltipBudgetExpense": "Pozycja budżetu produkcji",
    "expenseDetailsPopover": {
      "title": "Szczegóły kosztu",
      "vendor": "Dostawca",
      "category": "Kategoria",
      "committed": "Zadeklarowano",
      "actual": "Faktycznie",
      "receipts": "Paragony",
      "edit": "Edytuj"
    }
  },
  "ReconciliationFilters": {
    "invoice_status": {
      "AWAITING_APPROVAL": "Oczekuje na zatwierdzenie",
      "APPROVED": "Zatwierdzono",
      "PAID": "Opłacono",
      "DECLINED": "Odrzucono"
    }
  },
  "EntityListViewSwitch": {
    "gridView": "Widok kafelków",
    "listView": "Widok listy"
  },
  "EntityListSortSelect": {
    "sort": "Sortuj",
    "placeholder": "Sortuj",
    "noSort": "Bez sortowania",
    "sortAsc": "(A→Z)",
    "sortDesc": "(Z→A)"
  },
  "EntityGridSelectionToolbar": {
    "selectAllItems": "Zaznacz wszystkie"
  },
  "EntityGridListItem": {
    "selectItem": "Zaznacz {{key}}",
    "deselectItem": "Odznacz {{key}}"
  },
  "EntityListRow": {
    "validationFailed": "Błąd danych",
    "validationDetailsTitle": "Szczegóły błędu walidacji",
    "tryDisplayAnyway": "Wyświetl mimo to",
    "hideUnsafePreview": "Ukryj podgląd",
    "renderCrashed": "Nie udało się wyrenderować tego elementu",
    "renderTryAgain": "Spróbuj ponownie"
  },
  "EntityGridTileSizeSlider": {
    "size": "Rozmiar",
    "thumbnailSizeAria": "Rozmiar miniatur"
  },
  "SortableEntityGrid": {
    "itemsAriaLabel": "Elementy"
  },
  "EntityEmptyState": {
    "nothingHereYet": "Nic tu jeszcze nie ma.",
    "noResultsMatchFilters": "Brak wyników pasujących do filtrów.",
    "clearFilters": "Wyczyść filtry",
    "pageOutOfRangeTitle": "Ta strona nie istnieje",
    "pageOutOfRangeMessage": "Jesteś na stronie bez wyników. Wróć do ostatniej dostępnej strony.",
    "goToLastPage": "Przejdź do ostatniej strony"
  },
  "TableColumnManagerPopover": {
    "title": "Dostosuj kolumny",
    "shown": "Widoczne",
    "available": "Dostępne",
    "searchPlaceholder": "Szukaj pól...",
    "reset": "Resetuj",
    "apply": "Zastosuj",
    "cancel": "Anuluj",
    "fixed": "Stałe",
    "noShownResults": "Brak pasujących widocznych pól",
    "noAvailableResults": "Brak pasujących dostępnych pól",
    "triggerAriaLabel": "Zarządzaj kolumnami",
    "availableFieldsCount": "{{count}} pole",
    "availableFieldsCount_other": "{{count}} pól",
    "dragHandle": "Przeciągnij {{field}}",
    "changed": "Zmieniono",
    "showField": "Pokaż {{field}}",
    "hideField": "Ukryj {{field}}"
  },
  "TransferToWorkspaceDialog": {
    "fieldCurrentWorkspace": "Obecna przestrzeń robocza",
    "selectWorkspace": "Wybierz przestrzeń roboczą",
    "sameWorkspace": "Wybierz inną przestrzeń roboczą niż obecna",
    "save": "Przenieś",
    "transferFailed": "Przeniesienie nie powiodło się. Spróbuj ponownie."
  },
  "TransferToTeamDialog": {
    "fieldCurrentWorkspace": "Obecna przestrzeń robocza",
    "selectWorkspace": "Wybierz przestrzeń roboczą",
    "selectTeam": "Wybierz zespół",
    "save": "Przenieś",
    "transferFailed": "Przeniesienie nie powiodło się. Spróbuj ponownie."
  },
  "CustomFieldAddFlow": {
    "addTitle": "Dodaj pole niestandardowe",
    "createTitle": "Utwórz nowe pole",
    "searchPlaceholder": "Szukaj pól lub wpisz, aby utworzyć…",
    "createNamed": "Utwórz „{{name}}”",
    "addAsNewHint": "Dodaj jako nowe pole niestandardowe",
    "selectFieldsToAdd": "Wybierz pola do dodania",
    "alreadyAdded": "Już dodane",
    "currentlyAssigned": "Obecnie przypisane ({{count}})",
    "noCatalog": "Brak dostępnych pól niestandardowych. Utwórz je poniżej.",
    "noFieldsAvailable": "Brak dostępnych pól",
    "noFieldsAvailable_search": "Brak pól pasujących do wyszukiwania",
    "createNewField": "Utwórz nowe pole",
    "saveFields": "Zapisz pola",
    "cancel": "Anuluj",
    "createAndAssign": "Utwórz i przypisz",
    "stageDescription_search": "Przeszukaj istniejące pola niestandardowe lub utwórz nowe.",
    "stageDescription_create": "Skonfiguruj nowe pole niestandardowe.",
    "back": "Wstecz",
    "nameValidation_required": "Nazwa jest wymagana.",
    "nameValidation_minLength": "Nazwa musi zawierać co najmniej 3 znaki.",
    "nameValidation_duplicate": "Pole niestandardowe o tej nazwie już istnieje."
  },
  "IconPicker": {
    "placeholder": "Wybierz ikonę"
  },
  "ColorPicker": {
    "placeholder": "Wybierz kolor"
  },
  "ColorIconPicker": {
    "placeholder": "Wybierz ikonę i kolor"
  },
  "ResourceTypeIconPicker": {
    "placeholder": "Wybierz ikonę"
  },
  "FullPageErrorLog": {
    "copy": "Kopiuj",
    "copied": "Skopiowano"
  },
  "common": {}
}
